module.exports = __webpack_public_path__ + "img/loc_illu.a9983d65.png";